import { useCallback, useState } from "react";
import { apiFetch } from "../lib/api";

// Persists the caviste's establishment name. Public links are generated from
// the selected customer, not from the establishment name.
export function useEstablishment() {
    const [saving, setSaving] = useState(false);

        const saveEstablishment = useCallback(async (establishmentName: string): Promise<void> => {
        setSaving(true);
        try {
                const res = await apiFetch("/users/me/establishment", {
                          method: "PUT",
                          body: JSON.stringify({ establishmentName }),
                });
                if (!res.ok) {
                          throw new Error("Erreur lors de la sauvegarde de l'établissement.");
                }
                await res.json();
        } finally {
                setSaving(false);
        }
  }, []);

        return { saving, saveEstablishment };
}
